import React, { Component } from "react";
import Typography from "@material-ui/core/Typography";
import Drawer from "@material-ui/core/Drawer";
import Link from "@material-ui/core/Link";

export default class Footer extends Component {
  render() {
    return (
      <Drawer className="drawer" variant="permanent" anchor="bottom">
        <Typography align="center">
          簙引为北京安楹康思医学科技有限公司旗下产品，产品最终解释权归北京安楹康思医学科技有限公司所有
        </Typography>
        <Link
          component="button"
          variant="body2"
          onClick={() => {
            window.location.href = "https://beian.miit.gov.cn/";
          }}
        >
          京ICP备2021001914号
        </Link>
      </Drawer>
    );
  }
}
